import React from "react";
import styled from "styled-components";

const PageContainer = styled.div`
  max-width: 900px;
  margin: 4rem auto;
  padding: 0 1.5rem;
  color: #333;
  line-height: 1.6;
`;

const Terminos = () => (
  <PageContainer>
    <h1>Términos y Condiciones de Uso — Danyweb</h1>
    <h3>1. Aceptación de los Términos</h3>
    <p>Al contratar cualquiera de los servicios de diseño y desarrollo web ofrecidos por Danyweb, el cliente acepta expresamente los presentes Términos y Condiciones.</p>
    
    <h3>2. Propiedad Intelectual</h3>
    <p>Una vez saldado el pago total del proyecto, se transfieren al cliente los derechos de propiedad y uso sobre el diseño y código entregado.</p>
    
    <h3>3. Pagos y Cancelaciones</h3>
    <p>Para iniciar cualquier proyecto se requiere un anticipo del 50%. Los pagos realizados no son reembolsables una vez iniciado el proceso.</p>
  </PageContainer>
);

export default Terminos;